export const PAY = {
    REQUEST_PAYMENTLIST: "REQUEST_PAYMENTLIST",
    SUCCESS_SUCCESSFULLLIST: "SUCCESS_SUCCESSFULLLIST",
    FAILED_PAYMENTLIST: "FAILED_PAYMENTLIST",

    REQUEST_BILLING : "REQUEST_BILLING",
    SUCCESS_REQUEST_BILLING : "SUCCESS_REQUEST_BILLING",
    FAILED_BILLING : "FAILED_BILLING"
}
